import type { DoorsYearResult, YearResult } from '~/contracts/new-cars';

export default function isDoorsResult(
  result: YearResult
): result is DoorsYearResult {
  return 'doorCount' in result.next;
}
